<template lang="pug">
.container-player(id="FilePlayer-container")
  .player.video(v-if='playedMedium && (playedMedium.type === "Video" || playedMedium.type === "Audio")')
    video(:src='videoSrc', autoplay, controls, loop)
  .player.image(v-if='playedMedium && playedMedium.type === "Image"')
    img(:src='imageSrc')
  .player(v-if='playedMedium && (playedMedium.type === "PlayList" || playedMedium.type === "PlayListExtended")')
    h4.header
      MediumIcon(:medium="playedMedium")
      span &nbsp; {{ playedMedium.name }}
    hr.header
    br
    PlayListEditor(
      id="MediumEditor-playlistsEditor",
      :playList = "playedMedium",
      ref='PlayListEditor',
      :simpleMode = 'true',
    )
  .player(v-if='playedMedium && playedMedium.type === "PlayListLayout"')
    h4.header
      MediumIcon(:medium="playedMedium")
      span &nbsp; {{ playedMedium.name }}
    hr.header
    br
    LayoutEditorSmall(
      id="MediumEditor-layoutEditorSmall",
      :layoutMedium='playedMedium',
      ref='LayoutEditorSmall',
      @refreshLayout='refreshPlayListLayout()',
    )
  p.title(v-if='playedMedium && !playedMedium.type.startsWith("PlayList")')
    MediumIcon(:medium="playedMedium")
    span &nbsp; {{ playedMedium.name }}
</template>

<script>
import MediumIcon from '../Common/MediumIcon'
import ListItemMixin from '../Medium/ListItem.mixin'

export default {
  props: ['playedMedium'],
  mixins: [ListItemMixin],
  components: {
    MediumIcon,
    PlayListEditor: () => import('../Medium/PlayListEditor.vue'),
    LayoutEditorSmall: () => import('../Medium/LayoutEditorSmall.vue')
  },
  created () {
  },
  watch: {
    playedMedium: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    refreshPlayListLayout () {
      if (this.$refs.LayoutEditorSmall) this.$refs.LayoutEditorSmall.loadData()
    }
  },
  computed: {
    videoSrc () {
      if (!this.playedMedium) {
        return
      }
      if (this.playedMedium.File.id) {
        return this.getImagePath(this.playedMedium.File)
      }
      return this.getVideoPath(this.file)
    },
    imageSrc () {
      if (!this.playedMedium) {
        return
      }
      if (this.playedMedium.File.id) {
        return this.getImagePath(this.playedMedium.File)
      }
      return this.getImagePath(this.file)
    },
    file () {
      return this.$store.state.File.file_list.find(f => f.id === this.playedMedium.File)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-player {
  border: 0px dotted red;
  .video, .image {
    border: 0px dotted green;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    justify-content: space-around;
  }
  video, img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/File/Player.vue